// 金額・税率は整数。保存時の入力検証と金額確定はAPIが行う。
// Math.round(-0.5)との差を避け、負数も絶対値の四捨五入に揃える。
export const calculateBillingAmounts = (billing = {}) => {
  const total = Number(billing.total_amount || 0);
  const rate = Number(billing.tax_rate || 0);
  const carryover = Number(billing.carryover_amount || 0);
  const product = total * rate;
  const tax = Math.sign(product) * Math.floor((Math.abs(product) + 50) / 100);
  return {
    tax_amount: tax === 0 ? 0 : tax,
    current_billing_amount: total + tax,
    billing_total_amount: total + tax + carryover
  };
};

// 詳細・PDFは保存済み確定額を使う。未補正の過去請求も勝手に再計算しない。
export const savedBillingAmounts = (billing = {}) => {
  const gross = Number(billing.billing_total_amount || 0);
  const current = gross - Number(billing.carryover_amount || 0);
  return {
    tax_amount: current - Number(billing.total_amount || 0),
    current_billing_amount: current,
    billing_total_amount: gross
  };
};
